export const createQueryString = (params?: {
    filter?: Record<string, unknown>;
    page?: number;
    search?: string;
    itemsPerPage?: number;
    sort?: string;
}): string => {
    if (!params) {
        return "";
    }

    const { filter, ...restParams } = params;

    const isMeaningful = (value: unknown): boolean => {
        if (value === undefined || value === null) return false;
        if (typeof value === "string") return value.trim().length > 0;
        if (Array.isArray(value)) return value.length > 0;
        return true;
    };

    const stringParams: Record<string, string> = Object.entries(
        restParams,
    ).reduce(
        (acc, [key, value]) => {
            if (!isMeaningful(value)) return acc;
            return { ...acc, [key]: String(value) };
        },
        {} as Record<string, string>,
    );

    const searchParams = new URLSearchParams(stringParams);

    let filterString = "";
    if (filter) {
        filterString = Object.entries(filter)
            .filter(([, value]) => isMeaningful(value))
            .map(
                ([key, value]) =>
                    `filter[${key}]=${encodeURIComponent(String(value))}`,
            )
            .join("&");
    }

    const queryString = searchParams.toString();

    if (queryString && filterString) return `${queryString}&${filterString}`;
    if (filterString) return filterString;
    if (queryString) return queryString;
    return "";
};
